export default "__VITE_ASSET__Cy3fJM5v__"